import { takeLatest, all, put, fork, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../../actions/actions'

import { bank, putBank } from '../../../api/bankApi'

export default function* bankEditSaga() {
  yield all([
    fork(watchFetchBankEditRequest),
    fork(watchUpdateBankEditRequest),
    fork(watchEditBankBankContactFieldChangeRequest),
    fork(watchEditBankCorporateFieldChangeRequest),
    fork(watchEditBankEnabledFieldChangeRequest),
    fork(watchEditBankImageChangeRequest),
    fork(watchEditBankPrimaryColorChangeRequest),
    fork(watchEditBankSecondaryColorChangeRequest),
    fork(watchEditBankCleanRequest)
  ]);
}

function* watchFetchBankEditRequest() {
  yield takeLatest(
    actions.FETCH_BANK_EDIT_REQUEST,
    fetchBankEditRequest
  )
}

function* fetchBankEditRequest(bankData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(bank, bankData.value)
    yield put({ type: actions.FETCH_BANK_EDIT_SUCCESS, value: data })
    yield put(push(`/bank/edit/${bankData.value}`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_BANK_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchUpdateBankEditRequest() {
  yield takeLatest(
    actions.UPDATE_BANK_EDIT_REQUEST,
    updateBankRequestEdit
  )
}

function* updateBankRequestEdit(bank) {
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(putBank, bank.value)
    yield put({ type: actions.UPDATE_BANK_EDIT_SUCCESS, value: data })
    yield put({type:actions.AUTHENTICATED_USER_LOGO_UPDATE,value: bank.value.bankImage})
    yield put({type:actions.AUTHENTICATED_BANK_PRIMARY_COLOR_CHANGE,value:bank.value.primaryColor})
    yield put({type:actions.AUTHENTICATED_BANK_SECONDARY_COLOR_CHANGE,value:bank.value.secondaryColor})
    yield put(push(`/bank`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.EDIT_BANK_CLEAN_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.UPDATE_BANK_EDIT_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}

function* watchEditBankEnabledFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_BANK_ENABLED_FIELD_CHANGE_REQUEST,
    editBankEnabledFieldChangeRequest
  )
}

function* editBankEnabledFieldChangeRequest(enabled) {
  yield put({ type: actions.EDIT_BANK_ENABLED_FIELD_CHANGE, value: enabled.value })
}

function* watchEditBankBankContactFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_BANK_BANK_CONTACT_FIELD_CHANGE_REQUEST,
    editBankBankContactFieldChangeRequest
  )
}

function* editBankBankContactFieldChangeRequest(bankContact) {
  yield put({ type: actions.EDIT_BANK_BANK_CONTACT_FIELD_CHANGE, value: bankContact.value })
}

function* watchEditBankCorporateFieldChangeRequest() {
  yield takeLatest(
    actions.EDIT_BANK_CORPORATE_FIELD_CHANGE_REQUEST,
    editBankCorporateFieldChangeRequest
  )
}

function* editBankCorporateFieldChangeRequest(corporate) {
  yield put({ type: actions.EDIT_BANK_CORPORATE_FIELD_CHANGE, value: corporate.value })
}

function* watchEditBankImageChangeRequest() {
  yield takeLatest(
      actions.EDIT_BANK_IMAGE_UPLOAD_REQUEST,
      editBankImageChangeRequest
  )
}

function* editBankImageChangeRequest(image) {
  yield put({ type: actions.EDIT_BANK_IMAGE_UPLOAD, value: image.value })
}

function* watchEditBankPrimaryColorChangeRequest() {
  yield takeLatest(
      actions.BANK_PRIMARY_COLOR_CHANGE_REQUEST,
      editBankPrimaryColorChangeRequest
  )
}

function* editBankPrimaryColorChangeRequest(value) {
  yield put({ type: actions.BANK_PRIMARY_COLOR_CHANGE, value: value.value })
}

function* watchEditBankSecondaryColorChangeRequest() {
  yield takeLatest(
      actions.BANK_SECONDARY_COLOR_CHANGE_REQUEST,
      editBankSecondaryColorChangeRequest
  )
}

function* editBankSecondaryColorChangeRequest(value) {
  yield put({ type: actions.BANK_SECONDARY_COLOR_CHANGE, value: value.value })
}

function* watchEditBankCleanRequest() {
  yield takeLatest(
    actions.EDIT_BANK_CLEAN_REQUEST,
    editBankCleanRequest
  )
}

function* editBankCleanRequest() {
  yield put({ type: actions.EDIT_BANK_CLEAN })
}